import { SVGProps } from 'react';

export const CommentIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 1.5C4.41 1.5 1.5 3.91 1.5 7c0 1.68.876 3.19 2.27 4.22l-.47 2.78 3.09-1.545c.52.15 1.07.245 1.61.245 3.59 0 6.5-2.41 6.5-5.7S11.59 1.5 8 1.5Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
